import type { ExternalTableSchema } from '@packages/table-builder';
import {
  releaseIncludedItemColumns,
  releaseItemFilters,
  releaseItemSearchRequestParams,
  withReleaseIdEndpoint,
} from '@apps/customer/pages/release/shared/releaseItemTableShared';

export {
  releaseIncludedItemColumns as releaseItemColumns,
  releaseItemFilters,
  withReleaseIdEndpoint,
};

export const releaseIncludedItemsTable: ExternalTableSchema = {
  metadata: {
    title: 'Included Release items',
    entity: 'ReleaseIncludedItems',
  },
  dataSource: {
    endpoint: '/api/award/api/app/release/{id}/included-release-list',
    method: 'GET',
    rowIdField: 'id',
    requestParams: { ...releaseItemSearchRequestParams },
    filters: releaseItemFilters,
  },
  columns: releaseIncludedItemColumns,
  actions: {
    row: [
      { id: 'VIEW_DETAILS_RELEASE_INCLUDED', label: 'View Details' },
      { id: 'CALCULATE_TAX_RELEASE_INCLUDED', label: 'Calculate Tax' },
      { id: 'REMOVE_RELEASE_INCLUDED', label: 'Remove', variant: 'danger' },
    ],
    bulk: [{ id: 'REMOVE_BULK_RELEASE_INCLUDED', label: 'Remove', variant: 'danger' }],
    toolbar: {
      secondary: [
        { id: 'APPLY_FMV_RELEASE_INCLUDED', label: 'Apply FMV', requiresSelection: true, variant: 'secondary-white' },
        { id: 'CALCULATE_TAX_BULK_RELEASE_INCLUDED', label: 'Calculate Tax', requiresSelection: true, variant: 'primary' },
        { id: 'VIEW_CLOSING_PRICE_RELEASE_INCLUDED', label: 'View Closing Price', variant: 'primary-outline' },
      ],
    },
  },
  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    selection: { keyField: 'id', selectAllPages: true },
  },
};
